import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, UseFormReturn } from 'react-hook-form';
import {
  BankAccountFormSchemaType,
  useBankAccountFormSchema,
} from '../../../../../../common';

type UseAddBankAccountFormReturnType = UseFormReturn<BankAccountFormSchemaType>;

export const useAddBankAccountForm = (): UseAddBankAccountFormReturnType => {
  const { schema, defaultValues } = useBankAccountFormSchema();

  return useForm({
    defaultValues,
    resolver: zodResolver(schema),
  });
};
